"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readCcTokenizerConfig = exports.sendPaymentReceipt = exports.deleteSavedCard = exports.readProfileByPatient = exports.readPaymentsBySite = exports.readPayments = exports.deletePayment = exports.refundCardPayment = exports.createCardPayment = exports.createPayment = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.createPayment = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "payment/create-payment"
});
// D-002
exports.createCardPayment = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "payment/create-card-payment"
});
// D-002.840 Phase 2
exports.refundCardPayment = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "payment/refund-card-payment"
});
exports.deletePayment = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: 'get',
    path: 'payment/delete-payment'
});
exports.readPayments = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: 'get',
    path: 'payment/read-payments'
});
// D-002.58
exports.readPaymentsBySite = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: 'get',
    path: 'payment/read-paymentsbysite'
});
//D-002.53
exports.readProfileByPatient = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: 'get',
    path: 'payment/read-profilebypatient'
});
exports.deleteSavedCard = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "payment/delete-saved-card"
});
//D-002.611
exports.sendPaymentReceipt = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "payment/sendEmail"
});
// D-002 Phase 3 — Hosted iFrame Tokenizer public URL
exports.readCcTokenizerConfig = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "payment/read-cc-tokenizer-config"
});
// E-092 / D-002.032 — re-export CoPilot financial endpoints under PaymentEndpoint
var site_cardconnect_client_1 = require("./site-cardconnect-client");
Object.defineProperty(exports, "readSiteCardConnect", { enumerable: true, get: function () { return site_cardconnect_client_1.readSiteCardConnect; } });
Object.defineProperty(exports, "saveSiteCardConnect", { enumerable: true, get: function () { return site_cardconnect_client_1.saveSiteCardConnect; } });
Object.defineProperty(exports, "createSiteCardConnectMerchant", { enumerable: true, get: function () { return site_cardconnect_client_1.createSiteCardConnectMerchant; } });
Object.defineProperty(exports, "requestSiteCardConnectSignature", { enumerable: true, get: function () { return site_cardconnect_client_1.requestSiteCardConnectSignature; } });
Object.defineProperty(exports, "refreshSiteCardConnectStatus", { enumerable: true, get: function () { return site_cardconnect_client_1.refreshSiteCardConnectStatus; } });
Object.defineProperty(exports, "readSiteCardConnectGatewayCredentials", { enumerable: true, get: function () { return site_cardconnect_client_1.readSiteCardConnectGatewayCredentials; } });
Object.defineProperty(exports, "saveSiteCardConnectGatewayCredentials", { enumerable: true, get: function () { return site_cardconnect_client_1.saveSiteCardConnectGatewayCredentials; } });



//////////////////
// WEBPACK FOOTER
// ./src/api/payment/payment-client.ts
// module id = 994
// module chunks = 0 1 2